import { Salary } from "../../models/salary/salary";
import { getAsync, postAsync } from "./api-base";

export const getSalaries = async (system: string) => {
	const params = {
		reportType: 6,
	};
	const data = await getAsync<Salary[]>("mypages/salary", system, params);
	return data.map((s) => new Salary(s, system));
};

export const getSalaryPdf = async (system: string, date: Date) => {
	const params = {
		date: date,
	};
	const data = await postAsync<File, Record<string, Date>>(
		"reports/file?reportType=17&responseType=1",
		params,
		system,
		undefined,
		"blob",
	);
	return data;
};
